// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-upload-configure-charges{min-height:80vh}.menu-upload-configure-charges .filter-wrapper{height:33px}.menu-upload-configure-charges .filter-badge ::v-deep .v-badge__wrapper .v-badge__badge{font-size:10px;height:15px;min-width:15px;padding:3px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
